import { render, staticRenderFns } from "./HistoryIcon.vue?vue&type=template&id=6ffd6862&"
import script from "./HistoryIcon.vue?vue&type=script&lang=ts&"
export * from "./HistoryIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports